import React, { useEffect } from 'react';
import { googleConfig, googleApiConfig } from '../../config/googleConfig';

/**
 * Popup callback: exchange auth code on the FE, then postMessage to opener.
 */
const GoogleCallback = () => {
    useEffect(() => {
        const handleGoogleCallback = async () => {
            try {
                const urlParams = new URLSearchParams(window.location.search);
                const code = urlParams.get('code');
                const error = urlParams.get('error');

                if (error) {
                    throw new Error(`Google OAuth error: ${error}`);
                }
                if (!code) {
                    throw new Error('No authorization code received');
                }

                const tokenResponse = await fetch(googleApiConfig.tokenEndpoint, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: new URLSearchParams({
                        client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID || '',
                        client_secret: process.env.REACT_APP_GOOGLE_CLIENT_SECRET || '',
                        code,
                        grant_type: 'authorization_code',
                        redirect_uri: googleConfig.redirectUri,
                    }),
                });

                const tokenData = await tokenResponse.json();
                if (!tokenResponse.ok) {
                    throw new Error(
                        `Token exchange failed: ${tokenData.error_description || tokenData.error}`,
                    );
                }

                const userResponse = await fetch(
                    `${googleApiConfig.userInfoEndpoint}?access_token=${tokenData.access_token}`,
                );
                const userData = await userResponse.json();
                if (!userResponse.ok) {
                    throw new Error(
                        `Failed to get user info: ${userData.error_description || userData.error}`,
                    );
                }

                if (window.opener) {
                    window.opener.postMessage({
                        type: 'GOOGLE_AUTH_SUCCESS',
                        user: userData,
                        accessToken: tokenData.access_token,
                        idToken: tokenData.id_token,
                    }, window.location.origin);
                }
                window.close();
            } catch (error) {
                console.error('Google OAuth callback error:', error);
                if (window.opener) {
                    window.opener.postMessage({
                        type: 'GOOGLE_AUTH_ERROR',
                        error: error.message,
                    }, window.location.origin);
                }
                window.close();
            }
        };

        handleGoogleCallback();
    }, []);

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            fontFamily: 'Arial, sans-serif',
        }}>
            <div style={{ textAlign: 'center' }}>
                <h2>Completing Google Sign-In...</h2>
                <p>Please wait while we complete your authentication.</p>
            </div>
        </div>
    );
};

export default GoogleCallback;
